// Aquí está el slice de usuario
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  seguidoresInfo: null,
  seguidoresFailure: false,
  seguidoresError: null,
  seguidoresIsLoading: false,
};

const seguidoresSlice = createSlice({
  name: "seguidores",
  initialState,
  reducers: {
    seguidoresSuccess: (state, action) => {
      state.seguidoresInfo = action.payload.seguidoresInfo;
      state.seguidoresFailure = false;
      state.seguidoresIsLoading = false;
    },
    seguidoresFailure: (state, action) => {
      state.seguidoresFailure = true;
      state.seguidoresIsLoading = false;
      state.seguidoresError = action.payload; // mensaje de seguidoresError
    },
    seguidoresReset: (state) => {
      state.seguidoresInfo = null;
      state.seguidoresFailure = false;
      state.seguidoresError = null;
      state.seguidoresIsLoading = false;
    },
  },
});


export const {
  seguidoresSuccess,
  seguidoresFailure,
  seguidoresReset,
} = seguidoresSlice.actions;
export default seguidoresSlice.reducer;
